import React from "react";
import PropTypes from "prop-types";

class Loading extends React.Component {
  render() {
    return (
      <center>
        <div className="grey-text">
          {this.props.error ? (
            <div>
              <h2>Something went wrong</h2>
              <h3>
                Please{" "}
                <a href="" onclick="window.location.reload();">
                  refresh the page
                </a>{" "}
                and if the issue persists, contact support.
              </h3>
            </div>
          ) : this.props.loading ? (
            <div>
              <br />
              <p className="grey-text">Loading...</p>
              <br />
              <div className="load-wrapp">
                <div className="load-9">
                  <div className="spinner">
                    <div className="bubble-1" />
                    <div className="bubble-2" />
                  </div>
                </div>
              </div>
            </div>
          ) : (
            <p className="grey-text">{this.props.noDataMessage}</p>
          )}
        </div>
      </center>
    );
  }
}

Loading.propTypes = {
  // loading: PropTypes.boolean,
  noDataMessage: PropTypes.string,
  error: PropTypes.bool
};

export default Loading;
